import React from 'react';
import CertificationPage from '../../components/CertificationPage';
import { AwardIcon } from '../icons';

/**
 * CertificationPane — wraps the existing <CertificationPage embedded />
 * flow so the desktop shell gets all the same behavior as the website
 * (course creation, AI roadmap generation, sequential module unlock,
 * module quiz, final quiz, certificate PDF render via html2canvas+jsPDF,
 * 3-course limit, delete confirmation) without re-implementing 940+ lines.
 *
 * The Electron palette is applied via cert-overrides.css which is imported
 * by ElectronShell.jsx and scoped to body.electron-app .cert-electron-pane.
 *
 * `embedded={true}` tells the inner component to skip the website's
 * Header/Footer/marketing-hero — exactly what we want.
 *
 * The heading block above the wrapper gives this pane the same visual
 * anchor (eyebrow + H1) every other native pane has — without it, the
 * embedded view drops straight into the course list with no page title.
 */
export default function CertificationPane() {
  return (
    <div className="cert-electron-pane">
      <div className="pane" style={{ maxWidth: 'none', marginBottom: 14 }}>
        <div className="pane-eyebrow">
          <AwardIcon size={11} /> Certifications
        </div>
        <h1 className="pane-title">Certification Courses</h1>
      </div>
      <CertificationPage embedded />
    </div>
  );
}
